// extracted by mini-css-extract-plugin
export var TextAreaWrap = "TextArea-module--TextAreaWrap--NQB5i";
export var Inner = "TextArea-module--Inner--0Y3L+";
export var TextArea = "TextArea-module--TextArea--fQzLx";
export var Label = "TextArea-module--Label--SkbRp";